import React from "react";
import { Col, Form, Radio, Row } from "antd";
import { observer } from "mobx-react";

const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};

const radioMap = {
  papa: [
    { id: 1, text: "未来のキミは元気ですか？" },
    { id: 2, text: "壁にぶつかった時、ひらいてください。" },
    { id: 3, text: "いつかのキミに届きますように。" },
    { id: 4, text: "ハンカチの準備はできていますか？" },
    { id: 5, text: "親の心子知らず。" },
    { id: 6, text: "捨てたらアカン！！" },
    { id: 7, text: "パパ史上最高傑作。" },
    { id: 8, text: "これは絵本の形をしたタイムカプセルだ。" },
    { id: 9, text: "愛とは何か。答えはここにある。" },
    { id: 10, text: "キミのパパはグレートだ!!!" },
    { id: 11, text: "今世紀最高のラブストーリー。" }
  ],
  mama: [
    { id: 1, text: "未来のキミは元気ですか？" },
    { id: 2, text: "壁にぶつかった時、ひらいてください。" },
    { id: 3, text: "いつかのキミに届きますように。" },
    { id: 4, text: "ハンカチの準備はできていますか？" },
    { id: 5, text: "親の心子知らず。" },
    { id: 6, text: "捨てたらアカン！！" },
    { id: 12, text: "ママ史上最高傑作。" },
    { id: 8, text: "これは絵本の形をしたタイムカプセルだ。" },
    { id: 9, text: "愛とは何か。答えはここにある。" },
    { id: 13, text: "キミのママはグレートだ!!!" },
    { id: 11, text: "今世紀最高のラブストーリー。" }
  ]
};

class Panflet extends React.Component {
  state = {
    bandId: -1,
    saved: false
  };

  handleSaving = () => {
    this.props.book.parentToChild.changeBandId(this.state.bandId);
    this.props.order.nextStep();
    this.setState({ saved: true });
  };

  handleRadioChange = e => {
    this.setState({ bandId: e.target.value, saved: false })
  };

  componentWillMount() {
    if (this.props.book) {
      const { bandId } = this.props.book.parentToChild;
      this.setState({ bandId });
    }
  }

  render() {
    const { book, setpImage } = this.props;
    const radios = book.artistName === "nakagawa" ? radioMap.papa : radioMap.mama;
    const type = book.artistName === "nakagawa" ? 'papa' : 'mama';

    return (
      <div className="panflet">
        <div className="pd-15">
          <img
            style={{ width: "100%" }}
            src={require(`../../imgs/${setpImage}`)}
          />
          <div className="step m-t25">
            <div className="step-txt">{"下記の中から帯に印刷されるテキストデザインを選択してください。"}</div>
          </div>
          <Form layout="vertical">
            <Row>
              <Col key={0} span={24} style={{ marginTop: "20px" }}>
                <RadioGroup
                  onChange={this.handleRadioChange}
                  value={this.state.bandId}
                >
                  {radios.map((item) => (
                    <Radio
                      key={item.id}
                      style={radioStyle}
                      value={item.id}
                    >
                      {item.text.replace(/〇〇/g, book.parentToChild.creatorNickName)}
                    </Radio>
                  ))}
                </RadioGroup>
                <div
                  className="bandFigure"
                  style={{ width: "100%", display: "block", margin: "20px auto 0" }}
                >
                  <img
                    className="bandFigure_image"
                    src={require(`../../imgs/parent_to_child/band_${this.state.bandId === -1 ? "0" : ~~this.state.bandId}.png`)}
                    alt=""
                  />
                  <img
                    className="bandFigure_bg"
                    src={require(`../../imgs/parent_to_child/bg_panflet_${type}.png`)}
                    alt=""
                  />
                </div>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="pd-15">
          <div className="btn-wrap">
            <button
              onClick={this.handleSaving}
              className="btn product-btn"
              disabled={this.state.bandId === -1}
            >
              保存して次へ
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(Panflet);



// WEBPACK FOOTER //
// ./src/components/steps/PanfletParentToChild.js